export var isProductTypeEPPOnly = function (lineItems) {
    var hdppItems = lineItems.filter(function (item) { return item.productType === 'EPP'; });
    return hdppItems.length === 1 && lineItems.length === 1;
};
